module.exports = __webpack_public_path__ + "static/media/Robot limpiador solefish hidrotermal.3554b1ac.pdf";